import { EMPTY_STRING } from '@constants';

export const isStringEmpty = (str?: string) => str?.trim() === EMPTY_STRING;
